import React, { useState, useEffect } from 'react';
import Icon from 'components/mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import Drawer from 'components/common/Drawer';
import { connect } from 'react-redux';
import { getOffers } from 'hb-redux-store/feature/home/home.action';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import ProductCard from '../../mweb/ProductCard/ProductCard';
import PromoCard from '../../../feature/promo/PromoCard';
import { copyPlainStringToClipboard } from 'hb-redux-store/util/miscellaneousServices';
import { setAppNotification } from 'hb-redux-store/initial.action';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
import AnalyticsService from 'AnalyticsService';

const { clevertap } = AnalyticsService;

const Offers = props => {
  const { showOffers, onShowOffers, loadingOffers, offers, launchInfo } = props;
  const { customerType } = launchInfo || {};
  const { getOffers, setAppNotification, postAddItem, postRemoveItem } = props;
  const onCancel = () => {
    onShowOffers(false);
  };
  useEffect(() => {
    getOffers();
    const key = 'View Promotion';
    const payload = {
      source: 'Offers',
      customerType,
    };
    clevertap.sendCleverTapEvent(key, payload);
  }, []);

  const copyPromo = promo => {
    copyPlainStringToClipboard(promo).then(({ message }) => {
      setAppNotification(message);
    });
  };

  return (
    <Drawer
      title="OFFERS"
      placement="right"
      closable={true}
      onClose={onCancel}
      visible={showOffers}
      destroyOnClose={true}
      maskClosable={true}
      width={500}
      className="desktop-offers"
    >
      <div className="desktop-offers">
        {loadingOffers && <Loader position="absolute" />}
        {!loadingOffers &&
          (!offers ||
            (!offers.products?.length > 0 &&
              !offers.promocodes?.length > 0)) && (
            <div className="desktop-offers--empty">
              <Icon
                class="icon-empty-offers desktop-offers--illustration"
                width={180}
                height={133}
              />
              <div className="desktop-offers--oops">OOPS!</div>
              <div className="desktop-offers--description">
                We’re are on our way to bring some exciting offers for you.
                <br />
                Please check back later.
              </div>
              <Link
                to="/"
                onClick={onCancel}
                className="button button-primary full-width"
              >
                View Products
              </Link>
            </div>
          )}
        {offers?.promocodes && (
          <div>
            <div className="desktop-offers--title">Ongoing Promotions</div>
            {offers?.promocodes.map((promo, index) => (
              <PromoCard
                onCtaClick={copyPromo}
                promo={promo}
                ctaText="Copy"
                key={`${index}.${promo.promoCode}`}
              />
            ))}
            <div className="section-divider" />
          </div>
        )}

        {offers?.products && (
          <div>
            <div className="desktop-offers--title">Products on offer</div>
            {offers?.products.map(p => (
              <ProductCard
                product={p}
                key={p.productId}
                onIncrement={postAddItem}
                onDecrement={postRemoveItem}
                source="Offers"
              />
            ))}
          </div>
        )}
      </div>
    </Drawer>
  );
};

const mapStateToProps = ({ homeReducer, initialReducer }) => ({
  loadingOffers: homeReducer.loadingOffers,
  offers: homeReducer.offers,
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  getOffers,
  setAppNotification,
  postAddItem,
  postRemoveItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
